export default {
  companyEdit: {
    title: '公司管理',
    companyInfo: '公司資訊',

    form: {
      id: {
        label: 'ID'
      },
      name: {
        label: '公司名稱',
        placeholder: '請輸入公司名稱',
        feedback: {
          overWordLimit: '超出字數上限'
        }
      },
      newRoleName: {
        label: '角色名稱',
        placeholder: '請輸入公司管理員角色名稱',
        feedback: {
          overWordLimit: '超出字數上限'
        }
      },
      newUserEmail: {
        label: '用戶Email',
        placeholder: '請輸入公司管理員Email',
        feedback: {
          regex: '格式不符'
        }
      },
      activateTime: {
        label: '生效時間'
      },
      expireTime: {
        label: '過期時間'
      }
    }
  },
  Nop: {
    Btn: '登入電商中心',
    Hint: '電商中心已可使用，請先確認品牌人員權限已開啟，或先至權限設定新增品牌人員。',
  }
};
